export const NOT_AVAILABLE_STRING = "Não se aplica";
export const APPROVED_CHARGE_STRING = "Emissão de cobrança aprovada";
export const REPROVED_CHARGE_STRING = "Emissão de cobrança recusada";
export const WAITING_APPROVAL_EMISSION_STRING = "Aguardando aprovação para emissão";
export const WAITING_CONFIRMATION_NO_EMISSION_STRING = "Aguardando confirmação de não emissão";
export const FREE_CUSTOMER_STRING = "Isenção automática da cobrança";

export type BusinessEventStatusString =
  | typeof NOT_AVAILABLE_STRING
  | typeof APPROVED_CHARGE_STRING
  | typeof REPROVED_CHARGE_STRING
  | typeof WAITING_APPROVAL_EMISSION_STRING
  | typeof WAITING_CONFIRMATION_NO_EMISSION_STRING
  | typeof FREE_CUSTOMER_STRING;

export const NOT_AVAILABLE = 0;
export const WAITING_APPROVAL_EMISSION = 1;
export const WAITING_CONFIRMATION_NO_EMISSION = 2;
export const APPROVED_CHARGE = 3;
export const REPROVED_CHARGE = 4;
export const FREE_CUSTOMER = 5;

export type BusinessEventStatus =
  | typeof NOT_AVAILABLE
  | typeof APPROVED_CHARGE
  | typeof REPROVED_CHARGE
  | typeof WAITING_APPROVAL_EMISSION
  | typeof WAITING_CONFIRMATION_NO_EMISSION
  | typeof FREE_CUSTOMER;

export const BUSINESS_EVENT_STATUS_TYPES = [
  APPROVED_CHARGE,
  REPROVED_CHARGE,
  WAITING_APPROVAL_EMISSION,
  WAITING_CONFIRMATION_NO_EMISSION,
  FREE_CUSTOMER,
] as const;
export type eventStatus = typeof BUSINESS_EVENT_STATUS_TYPES[number];

export const BUSINESS_EVENT_STATUS_MAP: Record<BusinessEventStatus, BusinessEventStatusString> = {
  [NOT_AVAILABLE]: NOT_AVAILABLE_STRING,
  [APPROVED_CHARGE]: "Emissão de cobrança aprovada",
  [REPROVED_CHARGE]: "Emissão de cobrança recusada",
  [WAITING_APPROVAL_EMISSION]: "Aguardando aprovação para emissão",
  [WAITING_CONFIRMATION_NO_EMISSION]: "Aguardando confirmação de não emissão",
  [FREE_CUSTOMER]: "Isenção automática da cobrança",
};
